import styled from "styled-components";
import {Text1, Title1} from "../../../../styles/business-components";

import Image from '../../../../assets/images/business/b_about_img3.png'

export const Container = styled.div`
  padding: 20px 20px 100px;

  @media only screen and (${({theme}) => theme.media.medium}) {
    padding: 20px 100px 100px;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    padding: 20px 200px 100px;
  }

  @media only screen and (min-width: 1600px) {
    padding: 0 300px 200px 300px;
  }
`

export const Content = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;
  
  @media only screen and (${({theme}) => theme.media.small}) {
    flex-direction: row;
    align-items: center;
    gap: 50px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    gap: 100px;
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    gap: 50px;
  }
`

export const Title = styled(Title1)`
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 0;

  @media only screen and (${({theme}) => theme.media.small}) {
    margin-bottom: 20px;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 28px;
    line-height: 50px;
    font-weight: 600;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 32px;
    line-height: 60px;
    margin-bottom: 50px;
  }
`

export const Text = styled(Text1)`
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  margin-bottom: 0;

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    line-height: 40px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
    line-height: 60px;
    margin-bottom: 20px;
  }
`

export const ImageBlock = styled.div`
  background: url(${Image}) center no-repeat ${({theme}) => theme.business.colors.aboutImageBackground};
  background-size: contain;
  width: 120px;
  height: 120px;
  border-radius: 250px 250px 250px 2px;
  flex-basis: 30%;
  margin: auto;

  @media only screen and (${({theme}) => theme.media.small}) {
    width: 240px;
    height: 240px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    width: 500px;
    height: 500px;
    border-radius: 250px 250px 2px 250px;
  }
`

export const LargeScreen = styled.div`
  display: none;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: block;
  }
`

export const SmallScreen = styled.div`
  display: block;

  @media only screen and (${({theme}) => theme.media.small}) {
    display: none;
  }
`

export const Block = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  gap: 10px;
`